import { useState } from 'react';
import { PropTypes } from 'prop-types';
import './iconsEffect.css';

const ReloadIcon = ({ reloadFunction }) => {
  const [spinEffect, setSpinEffect] = useState('');
  const onClickEffect = async () => {
    setSpinEffect('fa-spin');
    reloadFunction();
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setSpinEffect('');
  };
  return (
    <i
      onClick={() => onClickEffect()}
      className={`fas fa-sync reloadIcon ${spinEffect}`}
    />
  );
};

ReloadIcon.propTypes = {
  reloadFunction: PropTypes.func.isRequired,
};

export default ReloadIcon;
